import { createContext, useContext, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isParticipantFlowPath } from '../constants/participantRoutes';

// Componentes
import Loader from '../components/Loader/Loader';

const LoaderContext = createContext();

export function LoaderProvider({ children }) {
    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');

    const showLoader = useCallback((customMessage) => {
        setMessage(customMessage || '');
        setIsLoading(true);
    }, []);

    const hideLoader = useCallback(() => setIsLoading(false), []);

    return (
        <LoaderContext.Provider value={{ showLoader, hideLoader }}>
            {children}
            {isLoading && (
                <Loader
                    message={message || t('common.loading', {
                        lng: isParticipantFlowPath(window.location.pathname)
                            ? i18n.resolvedLanguage
                            : 'pt-BR',
                    })}
                />
            )}
        </LoaderContext.Provider>
    );
}

export function useLoader() {
    return useContext(LoaderContext);
}
